import { useTranslation } from 'next-i18next'

export const useGetTimePast = (date: string): string => {
  const { t } = useTranslation(['statistics', 'generics'])
  const time = new Date(date).getTime()
  const now = new Date().getTime()
  const diff = now - time
  const seconds = Math.floor(diff / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  if (days) {
    return t('statistics:timeStamps.days', { days })
  } else if (hours) {
    return t('statistics:timeStamps.hours', { hours })
  } else if (minutes) {
    return t('statistics:timeStamps.minutes', { minutes })
  } else {
    return t('generics:justNow')
  }
}
